import featureEnabled from '../../util/feature_enabled'

export default async function dashboard (state, appOptions) {
  const Dashboard = (await import(/* webpackChunkName: 'component-dashboard' */ '../../components/dashboard')).default
  return new Dashboard({
    user: state.get('user'),
    showRemote: appOptions.mode !== 'integration',
    showPollEvRemote: featureEnabled(state.get('user'), 'alpha_tester'),
    showPresenterControls: featureEnabled(state.get('user'), 'alpha_tester'),
    allowRedirects: appOptions.allowRedirects,
    mode: state.get('mode'),
    state
  })
}
